export const isFiniteNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value)
